import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="yu-baby-rate-limit"
export default class extends Controller {
  static values = {
    liftedAt: String,
    reloadUrl: String
  }

  static outlets = ['yu-baby']

  connect() {
    this.scheduleReload()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  scheduleReload() {
    if (!this.hasLiftedAtValue) return

    if (this.timer) clearTimeout(this.timer)

    const liftedAt = new Date(this.liftedAtValue)
    const delay = liftedAt - Date.now() + 10000 // ちょうどだとエラーになる可能性があるためマージン追加

    if (delay <= 0) {
      this.reloadFormArea()
    } else {
      this.timer = setTimeout(() => this.reloadFormArea(), delay)
    }
  }

  reloadFormArea() {
    if (!this.hasYuBabyOutlet) return
    this.yuBabyOutlet.formAreaTarget.src = this.reloadUrlValue
  }
}
